import { ExperiencePurchaseItem, FieldType, WeightUnit } from "types";

export interface WeightLoad {
    value: number;
    unit: WeightUnit;
}

const KG_TO_LBS_FACTOR = 2.2046;
const LBS_TO_KG_FACTOR = 1 / KG_TO_LBS_FACTOR;

export const flipWeightUnit = (fromWeight: WeightLoad): WeightLoad => {
    return fromWeight.unit === WeightUnit.LBS
        ? { value: Math.round(fromWeight.value * LBS_TO_KG_FACTOR * 100) / 100, unit: WeightUnit.KG }
        : { value: Math.round(fromWeight.value * KG_TO_LBS_FACTOR * 100) / 100, unit: WeightUnit.LBS };
};

export const calculateTotalWeightForItem = (item: ExperiencePurchaseItem) => {
    const weightFields = item.guests
        .flatMap((guest) => guest.formResponse?.fields ?? [])
        .filter((field) => field.type === FieldType.WEIGHT && !!field.value);
    let weightInKgs = 0;
    let weightInLbs = 0;
    for (const weightField of weightFields) {
        const guestWeight = Number.parseFloat(weightField.value);
        if (!Number.isNaN(guestWeight)) {
            if (weightField.unit === WeightUnit.KG) {
                weightInKgs += guestWeight;
            } else {
                weightInLbs += guestWeight;
            }
        }
    }
    return { weightInKgs, weightInLbs };
};

export const combineWeights = (weightInKgs: number, weightInLbs: number) => {
    if (weightInKgs + weightInLbs > 0) {
        const weightInKgsConvertedToLbs = flipWeightUnit({ value: weightInKgs, unit: WeightUnit.KG }).value;
        if (weightInLbs > weightInKgsConvertedToLbs) {
            const totalWeightInLbs = weightInLbs + weightInKgsConvertedToLbs;
            return { value: totalWeightInLbs, unit: WeightUnit.LBS };
        } else {
            const totalWeightInKgs = weightInKgs + flipWeightUnit({ value: weightInLbs, unit: WeightUnit.LBS }).value;
            return { value: totalWeightInKgs, unit: WeightUnit.KG };
        }
    }
};
